export default "__VITE_ASSET__BdsjRRdf__"